module.exports = __webpack_public_path__ + "static/media/2.question.14fc33b9.mp4";